import { createBrowserRouter, Navigate } from 'react-router-dom';
import App from '@/App'
import Login from '@/pages/user/login'
import Register from '@/pages/user/register'
import PublicProfile from '@/pages/user/profile'
import Personal from '@/pages/user/personal'
import Modify from '@/pages/user/personal/modify'
import Info from '@/pages/user/personal/info'
import MyPosts from '@/pages/user/personal/myposts'
import CreatePost from '@/pages/posts/create'
import PostDetail from '@/pages/posts/detail'
import Message from '@/pages/user/message'
import NotFound from '@/pages/notfound'
import PasswordReset from '@/pages/user/passwordreset'
import MyTags from '@/pages/user/personal/tags'
import AdminUsers from '@/pages/user/admin'
import Security from '@/pages/user/personal/security'
import ChatSettings from '@/pages/user/personal/chatsettings'
import EmailSettings from '@/pages/user/personal/email'
import MyApplications from '@/pages/user/personal/applications'
import MyReviews from '@/pages/user/personal/reviews'
import MyFeedback from '@/pages/user/personal/feedback'
import MyFavorites from '@/pages/user/personal/favorites'
import NotificationSettings from '@/pages/user/personal/alerts'
import RecommendationHistory from '@/pages/user/personal/recommendationhistory'
import Reports from '@/pages/user/personal/reports'
import Statistics from '@/pages/user/admin/Statistics'
import AuditEvents from '@/pages/user/admin/AuditEvents'
import PostManage from '@/pages/posts/manage'
import AccessBoundary, { AdminGuard } from '@/components/adminaccess'
import DesktopNavigation from '@/components/desktopnavigation'
import BrowseHistory from '@/components/browsehistory'

// HashRouter 用于 GitHub Pages 页面展示
// const router = createHashRouter([
  // BrowserRouter 用于服务器部署页面展示 
  const router = createBrowserRouter([
  { element: <BrowseHistory><DesktopNavigation><AccessBoundary /></DesktopNavigation></BrowseHistory>, children: [
  // 首页
  { path: '/users/:userId', element: <PublicProfile /> },
  {
    path: '/',
    element: <App />,
  },
  // 发布搭子招募
  {
    path: '/posts/create',
    element: <CreatePost />,
  },
  {
    path: '/posts/:postId',
    element: <PostDetail />,
  },
  { path: '/posts/:postId/manage', element: <PostManage /> },
  { path: '/forgot-password', element: <PasswordReset /> },
  { path: '/reset-password', element: <PasswordReset confirm /> },
  // 兼容旧管理页链接，统一进入个人中心的二级页面。
  { path: '/admin/users', element: <Navigate to="/personal/admin" replace /> },
  // 登录页
  {
    path: '/login',
    element: <Login />,
  },
  // 注册页
  {
    path: '/register',
    element: <Register />,
  },
  // 个人中心页
  {
    path: '/personal',
    element: <Personal />,
    children: [
      { path: 'admin', element: <AdminGuard embedded><AdminUsers /></AdminGuard> },
      { path: 'security', element: <Security /> },
      { path: 'email', element: <EmailSettings /> },
      { path: 'applications', element: <MyApplications /> },
      { path: 'applications/:applicationId', element: <MyApplications /> },
      { path: 'reviews', element: <MyReviews /> },
      { path: 'feedback', element: <MyFeedback /> },
      { path: 'favorites', element: <MyFavorites /> },
      { path: 'notification-settings', element: <NotificationSettings /> },
      { path: 'recommendation-history', element: <RecommendationHistory /> },
      { path: 'reports', element: <Reports /> },
      { path: 'report-management', element: <AdminGuard embedded><Reports admin /></AdminGuard> },
      { path: 'chat-settings', element: <ChatSettings /> },
      { path: 'statistics', element: <AdminGuard embedded><Statistics /></AdminGuard> },
      { path: 'audit', element: <AdminGuard embedded><AuditEvents /></AdminGuard> },
      { path: 'tags', element: <MyTags /> },
      // 个人信息页
      {
        index: true,
        path: 'info',
        element: <Info />,
      },
      // 我的帖子页
      {
        path: 'myposts',
        element: <MyPosts />,
      },
      // 兼容旧的我的帖子地址
      {
        path: 'posts',
        element: <Navigate to="/personal/myposts" replace />,
      },
      // 修改密码页
      {
        path: 'modify',
        element: <Modify />,
      },
    ]
  },
  // 消息页
  {
    path: '/message',
    element: <Message />,
  },
  { path: '/message/:conversationId', element: <Message /> },
  { path: '/message/notifications', element: <Message notifications /> },
  // 页面不存在，跳转到404页面
  {
    path: '*',
    element: <NotFound />,
  }
  ] },
]);

export default router;
